import React from 'react';

import i18n from '@client/utils/i18n';
import { SpectrogramMapItem } from '@ledium/types';
import { Description, GroupSelect, LediumForm, TitleAndDescription, UniqueName } from '@ledium/ui-common';
import { Container } from '@mui/material';

import ProjectEditorLightRecipeInfo from './Components/ProjectEditorLightRecipeInfo';
import ProjectEditorSelectRecipe from './Components/ProjectEditorSelectRecipe';
import ProjectEditorSpectrumMixList from './Components/ProjectEditorSpectrumMixList';

interface ProjectEditorViewProps {
    onSave: () => void;
    onClose: () => void;
    spectrogramMap: SpectrogramMapItem[];
}

const ProjectEditorView = ({ onSave, onClose, spectrogramMap }: ProjectEditorViewProps) => (
    <Container>
        <LediumForm onSubmit={() => onSave()} onCancel={onClose} header={<TitleAndDescription />}>
            <UniqueName />
            <Description />
            <ProjectEditorSelectRecipe />
            <GroupSelect
                label={i18n('select_group_of_the_spectrum_mixes')}
                disabled={spectrogramMap.some((e) => !!e.spectrumMixId)}
                disabledMessage={i18n('project_editor_disabled_tree_selection')}
            />

            <ProjectEditorLightRecipeInfo />
            <ProjectEditorSpectrumMixList />
        </LediumForm>
    </Container>
);

export default ProjectEditorView;
